export default class BaseModel {
  public toJSON(): any {
    let json: any = {};
    Object.getOwnPropertyNames(this).map(
      (prop: string) => (json[prop] = (this as any)[prop])
    );
    return JSON.parse(JSON.stringify(json));
  }
}
